module.exports = __webpack_public_path__ + "img/unionpay.89ec1c7b.png";